import React, { useState } from 'react';
import { Box, Button, IconButton, Paper, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useIsMobile } from '../hooks/useIsMobile';
import { cupAuthService } from '../auth/cupAuthService';
import { env } from '../../env';

const DISMISS_KEY = 'app_install_banner_dismissed';
const DISMISS_DAYS = 30;

function isDismissed(): boolean {
  const dismissed = localStorage.getItem(DISMISS_KEY);
  if (!dismissed) return false;
  const dismissedAt = parseInt(dismissed, 10);
  const daysSince = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);
  return daysSince < DISMISS_DAYS;
}


export const AppInstallBanner: React.FC = () => {
  const isMobile = useIsMobile();
  const [visible, setVisible] = useState(!isDismissed());

  const credentials = cupAuthService().getCredentials();

  // Show banner only for configured cup keys (comma-separated in env)
  const allowedKeys = env.bannerCupKeys
    .split(',')
    .map(k => k.trim())
    .filter(k => k.length > 0);
  const cupEnabled = allowedKeys.length > 0 && credentials.tenantKey != null && allowedKeys.includes(credentials.tenantKey);

  if (!cupEnabled || !isMobile || !visible) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, Date.now().toString());
    setVisible(false);
  };

  const handleOpen = () => {
    window.location.href = '/app';
  };

  return (
    <Paper
      elevation={4}
      style={{
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#ee6c4d',
        color: '#ffffff',
      }}
    >
      <Box display="flex" alignItems="center" flex={1}>
        <GetAppIcon style={{ color: '#ffffff', marginRight: 10, fontSize: 28 }} />
        <Typography variant="body1" style={{ fontWeight: 700, color: '#ffffff' }}>
          Auch als App verfügbar!
        </Typography>
      </Box>
      <Button
        size="small"
        variant="contained"
        onClick={handleOpen}
        style={{
          marginRight: 4,
          whiteSpace: 'nowrap',
          backgroundColor: '#ffffff',
          color: '#ee6c4d',
          fontWeight: 700,
        }}
      >
        Mehr erfahren
      </Button>
      <IconButton size="small" onClick={handleDismiss} aria-label="Banner schließen" style={{ color: '#ffffff' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Paper>
  );
};
